import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Eye, EyeOff } from 'lucide-react';
import { useSkipCategories } from '../../context/SkipCategoriesContext';
import SkipCategoriesModal from './SkipCategoriesModal';

/**
 * Button to open skip categories modal
 * Shows badge with active categories count
 */
export default function SkipCategoriesButton({ tweetId, tweetSource, className = '' }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { getSkipCategories, isSkipped } = useSkipCategories();

  const skipCategories = getSkipCategories(tweetId);
  const hasSkipCategories = skipCategories.length > 0;

  return (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsModalOpen(true);
        }}
        className={`tweet-action-button ${className}`}
        title={hasSkipCategories ? `Skipped (${skipCategories.length} categories)` : 'Skip this quote'}
      >
        {hasSkipCategories ? (
          <EyeOff size={18} className="text-red-500" />
        ) : (
          <Eye size={18} />
        )}
      </button>

      {isModalOpen && createPortal(
        <SkipCategoriesModal
          tweetId={tweetId}
          tweetSource={tweetSource}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />,
        document.body
      )}
    </>
  );
}
